import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import VModal from 'vue-js-modal';
import router from './router';

import config from './config/config.json';

import moment from 'moment';
Vue.prototype.$moment = moment;
moment.locale('ko');

Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true });

/*
 Vue.prototype.$axios = axios.create({
	baseURL: config.BASE_URL,
	headers: {
		'Content-Type': 'application/json',
	},
});
*/

Vue.prototype.$axios = null;
if (navigator.userAgent.indexOf('iPhone') > 0 ||
  navigator.userAgent.indexOf('iPad') > 0 ||
  navigator.userAgent.indexOf('iPod') > 0 ||
  navigator.userAgent.indexOf('Android') > 0) {
  Vue.prototype.$axios = axios.create({
    baseURL: config.BASE_URL_MOBILE,
    timeout:100000,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });
  //alert("모바일~~~~" + config.BASE_URL_MOBILE);
} else {
  Vue.prototype.$axios = axios.create({
    baseURL: config.BASE_URL,
    timeout: 100000,
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });  
};


// import infochatter3AnswerUikit from "./uikit/infochatter3AnswerUikit.umd.min";
// import "./uikit/infochatter3AnswerUikit.css";
// Vue.use(infochatter3AnswerUikit);
import Infochatter3AnswerUikit from './uikit/infochatter3-answer-uikit';
Vue.use(Infochatter3AnswerUikit);

import './assets/css/style.css';

new Vue({
	el: '#app',
	render: h => h(App),
	router,
});




// WEBPACK FOOTER //
// ./src/main.js